<template>
  <div>
    <div
      class="alert bg-rgba-danger alert-dismissible mb-2"
      role="alert"
      v-if="type == 'danger'"
      :class="docusign ? 'needsConsent' : ''"
      @click="docusign ? docusignGrantAccess() : null"
    >
      <button
        type="button"
        class="close"
        data-dismiss="alert"
        aria-label="Close"
        v-if="dismissable == 'true'"
      >
        <span aria-hidden="true">&times;</span>
      </button>
      <div class="d-flex align-items-center">
        <em class="bx bx-error"></em>
        <span :innerHTML="text"></span>
      </div>
    </div>
    <div
      class="alert bg-rgba-success alert-dismissible mb-2"
      role="alert"
      v-if="type == 'success'"
    >
      <button
        type="button"
        class="close"
        data-dismiss="alert"
        aria-label="Close"
        v-if="dismissable == 'true'"
      >
        <span aria-hidden="true">&times;</span>
      </button>
      <div class="d-flex align-items-center">
        <em class="bx bx-like"></em>
        <span :innerHTML="text"></span>
      </div>
    </div>
    <div
      class="alert bg-rgba-warning alert-dismissible mb-2"
      role="alert"
      v-if="type == 'warning'"
    >
      <button
        type="button"
        class="close"
        data-dismiss="alert"
        aria-label="Close"
        v-if="dismissable == 'true'"
      >
        <span aria-hidden="true">&times;</span>
      </button>
      <div class="d-flex align-items-center">
        <em class="bx bx-error-circle"></em>
        <span :innerHTML="text"></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Alert",
  props: ["type", "text", "dismissable", "docusign"],
  methods: {
    docusignGrantAccess() {
      const redirect_uri = window.location.origin;

      location.href = `${process.env.VUE_APP_DOCUSIGN_AUTH_URL}/oauth/auth?response_type=code&scope=signature%20impersonation&client_id=${process.env.VUE_APP_DOCUSIGN_CLIENT_ID}&state=state&redirect_uri=${redirect_uri}/contracts/callback&login_hint=hint`;
    }
  }
};
</script>

<style scoped>
.needsConsent {
  cursor: pointer;
  text-decoration: underline;
}
</style>
